import React, { createContext, useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

import useUser from '../hook/useUser';
import { apiList } from '../api/callAPI';
import * as alertConstants from '../constants/alertMsg';
import * as urlConstants from '../constants/url';

const AllUserListContext = createContext();

export const AllUserListProvider = ({ children }) => {
  const history = useHistory();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const [allUserList, setAllUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const fetchAllUserList = () => {

    apiList.getUsers()
      .then(res => {
        if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;
        if (res.status === 200) {
          setAllUserList(res.data.result);

        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  useEffect(() => {
    if (!userData) return;

    fetchAllUserList();
  }, [userData])

  return (
    <AllUserListContext.Provider
      value={{
        allUserList,
        setAllUserList,
        selectedUser,
        setSelectedUser
      }}
    >
      {children}
    </AllUserListContext.Provider>
  )
}

export default AllUserListContext;